package kz.dentalcrm.app.expectations

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

private object NoOpHapticFeedbackProvider : HapticFeedbackProvider {
    override fun performHapticFeedback() {
        // No haptic feedback on Web
    }
}

@Composable
actual fun rememberHapticFeedback(): HapticFeedbackProvider {
    return remember { NoOpHapticFeedbackProvider }
}
